// src/config/roleConfig.js
export const ROLE_NAMES = {
  APP_OWNER: "App Owner",
  ADMIN: "Admin",
  CLIENT: "Client",
  EMPLOYEE: "Employee",
};